import React from 'react';

function Diversity({ fill, className }) {
    return (
        <svg
            width="180"
            height="168"
            viewBox="0 0 180 168"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M80.7729 116.083C213.076 248.386 -67.887 248.386 64.4159 116.083C-67.887 248.386 -67.887 -32.5767 64.4159 99.7262C-67.887 -32.5767 213.076 -32.5767 80.7729 99.7262C213.076 -32.5767 213.076 248.386 80.7729 116.083Z"
                fill={fill}
            />
        </svg>
    );
}

export default Diversity;
